import { HardwareSupplierFilterKeyType } from 'opensolar-common'
import { DisconnectIcon, HelpCircleOutlinedIcon } from 'opensolar-ui'
import { useGetSupplierConfig } from 'pages/ordering/hooks/useGetSupplierConfig'
import React from 'react'
import { useHistory } from 'react-router-dom'
import SupplierIntegrationPricingLabel from './SupplierIntegrationPricingLabel'

type TieredPriceOnApplicationPricingLabelProps = {
  supplierFilterKey?: HardwareSupplierFilterKeyType
  variant?: 'default' | 'small'
}

const TieredPriceOnApplicationPricingLabel: React.FC<TieredPriceOnApplicationPricingLabelProps> = ({ supplierFilterKey, variant = 'default' }) => {
  const history = useHistory()
  const { getIsConnected } = useGetSupplierConfig()
  const isConnected = supplierFilterKey ? getIsConnected(supplierFilterKey) : false

  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    if (isConnected) {
      history.push('/shop')
    } else {
      history.push('/shop_suppliers', { filterKey: supplierFilterKey })
    }
  }

  return (
    <SupplierIntegrationPricingLabel
      variant={variant}
      iconBadgeStyle={{ backgroundColor: 'transparent' }}
      labelText={isConnected ? 'Price pending' : 'Connect for price'}
      icon={isConnected ? <HelpCircleOutlinedIcon size={14} /> : <DisconnectIcon width={14} height={12} />}
      tooltipImageUrl={isConnected ? undefined : `${window.PUBLIC_URL}/images/poa-with-price-tiers-tooltip.svg`}
      tooltipHeading={isConnected ? 'Price pending' : 'See your trade price'}
      tooltipBody={
        isConnected
          ? 'Your account is being set up with this supplier. Pricing will appear here once ready.'
          : 'Connect your account to get personalized pricing assigned to your account.'
      }
      tooltipLinkText={isConnected ? '' : 'Take me there'}
      onLinkClick={handleLinkClick}
    />
  )
}

export default TieredPriceOnApplicationPricingLabel
